// Defence-in-depth against an infinite cross-host redirect loop. If the browser bounces between
// Hub hosts more than CAP times inside WINDOW_MS, we stop bouncing and render where we are. A
// normal one-off bounce is cleared on the next clean render (clearBounceGuard), so the cap only
// ever trips during a genuine rapid loop.
const KEY = 'eh.hostbounce';
const CAP = 5;
const WINDOW_MS = 10_000;

type BounceRecord = { count: number; firstTs: number };

// Count this bounce. Returns whether it is allowed and the running count. Fails open (allows) if
// sessionStorage is unavailable — the guard is a safety net, never a gate on real users.
export function recordBounce(now: number = Date.now()): { allow: boolean; count: number } {
  let prev: BounceRecord | null = null;
  try {
    const raw = sessionStorage.getItem(KEY);
    prev = raw ? (JSON.parse(raw) as BounceRecord) : null;
  } catch {
    return { allow: true, count: 1 };
  }
  const within = !!prev && now - prev.firstTs <= WINDOW_MS;
  const count = (within ? prev!.count : 0) + 1;
  const firstTs = within ? prev!.firstTs : now;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ count, firstTs }));
  } catch {
    /* ignore — see fail-open note above */
  }
  return { allow: count <= CAP, count };
}

export function clearBounceGuard(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
